export default __webpack_public_path__ + "static/media/launchpad-artists-.54ef80fa.png";